import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { i18n } from "@/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    return localStorage.getItem("arven_lang") || "fr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("arven_lang", lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const value = useMemo(() => {
    const t = i18n[lang] || i18n.fr;
    return { lang, setLang, t };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}
